import React from "react";
import styled from "styled-components";
import * as AppActions from "../../AppActions";
import Constants from "../../Constants";
import BaseSection from "../../Components/BaseSection";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import TextSection from "../../Components/TextSection";
import * as SocialIcon from "../../Components/SocialIcon";
import { useOutlet } from "reconnect.js";

import AboutSection from "../../Components/AboutSection";
import ExtendSection from "../../Components/ExtendSection";
import TeamContactSection from "../../Components/TeamContactSection";

function Landing(props) {
  const lang = props.lang || "tw";

  return (
    <Wrapper id="landing-page">
      <Navbar lang={lang} />

      <div
        className="content"
        style={{
          backgroundImage: 'url("/banner.png")',
          width: "100vw",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "90vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src="/logo-icon1.png" style={{ height: "15vh" }} />

        <div
          style={{
            width: "80%",
            marginTop: "15vh",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <div style={{ color: "#ffe500", fontSize: "5em" }}>WELCOME&nbsp;</div>
          <div style={{ color: "#6767ff", fontSize: "5em" }}>TO&nbsp;</div>
          <div style={{ color: "#ffffff", fontSize: "5em" }}>HINFT</div>
        </div>
      </div>

      <AboutSection lang={lang} />

      <ExtendSection lang={lang} />

      <TeamContactSection lang={lang} />
    </Wrapper>
  );
}

const Wrapper = styled.div``;

export default Landing;
